import { Component, ViewChild } from '@angular/core';
import { AFSTextareaInputComponent, AFSSelectInputComponent, AFSDateTimeInputComponent, AFSRadioButtonComponent, AFSRadioButtonContainerComponent } from "@afs-ng/inputs";
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { dayjs } from '@afs-ng/core'
import { AssignEmployeesComponent } from "../../assign-components/assign-employees/assign-employees.component";
import { SupportAppointmentRequestConfirmation } from 'src/app/_provider/support/support.types';

@Component({
    selector: 'appointment-assign-reject',
    templateUrl: './appointment-assign-reject.component.html',
    styleUrls: ['./appointment-assign-reject.component.scss', '../../assign.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, AFSTextareaInputComponent, AssignEmployeesComponent, AFSSelectInputComponent, AFSDateTimeInputComponent, AFSRadioButtonComponent, AFSRadioButtonContainerComponent, ReactiveFormsModule]
})
export class AppointmentAssignRejectComponent {

  @ViewChild("assignEmployees") assignEmployees!: AssignEmployeesComponent

  public durationOptions = [
    {value: 15, name: "15 Minuten"},
    {value: 30, name: "30 Minuten"},
    {value: 45, name: "45 Minuten"},
    {value: 60, name: "1 Stunde"},
    {value: 120, name: "2 Stunden"},
    {value: 180, name: "3 Stunden"},
    {value: 240, name: "4 Stunden"},
    {value: 300, name: "5 Stunden"},
    {value: 360, name: "6 Stunden"},
    {value: 420, name: "7 Stunden"},
    {value: 480, name: "8 Stunden"},
  ]
  public selectedEmployeeIds: number[] = []
  public form: FormGroup = this.formBuilder.group({
    accepted: [false],
    selectedDuration: [60],
    rejectMessage: [""],
    withNewAppointment: ["0"],
    newAppointmentDate: [dayjs().add(1, "day").hour(8).minute(0).second(0)],
  })

  public get appointmentRequestOptions(): SupportAppointmentRequestConfirmation{
    return {
      ...this.form.value,
      employeeIds: this.selectedEmployeeIds,
      withNewAppointment: this.form.get("withNewAppointment").value === "1",
      appointmentDate: this.form.get("newAppointmentDate").value.toDate()
    }
  }

  public get disabled(): boolean{
    if(this.form.get("withNewAppointment").value == "1") return this.selectedEmployeeIds.length === 0
    return false
  }

  constructor(
    private formBuilder: FormBuilder
  ){}


  public clear(){
    if(this.assignEmployees) this.assignEmployees.clear()
    this.form.reset({
      accepted: false,
      employeeIds: [],
      selectedDuration: 60,
      rejectMessage: "",
      withNewAppointment: "0",
      newAppointmentDate: dayjs().add(1, "day").hour(8)
    })
  }

}
